var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "textBox",
      on: { mouseenter: _vm.mouseEnter, mouseleave: _vm.mouseLeave },
    },
    [
      _c(
        "div",
        {
          ref: "textBoxWrap",
          staticClass: "textOverflow",
          class: { multiLine: _vm.lines !== "1" },
          style: {
            width: _vm.width,
            "-webkit-line-clamp": _vm.lines !== "1" ? _vm.lines : null,
          },
        },
        [_vm._t("default")],
        2
      ),
      _c("el-tooltip", {
        ref: "tooltip",
        staticClass: "item",
        attrs: {
          effect: _vm.effect,
          content: _vm.tooltipContent,
          placement: "top",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }